import React from "react";
import { Alert } from "react-bootstrap";
import { CSSTransition } from "react-transition-group";
import "./Notification.css";

class Notification extends React.Component {
  constructor(props) {
    super(props);

    this.handleDismiss = this.handleDismiss.bind(this);
  }

  handleDismiss() {
    const { handleStatusChange } = this.props;

    handleStatusChange();
  }

  render() {
    const { show, type, header, text } = this.props;

    return (
      <CSSTransition
        in={show}
        timeout={300}
        classNames="Notification"
        unmountOnExit
      >
        <Alert
          key="alert1"
          bsStyle={type}
          className="Notification"
          onDismiss={this.handleDismiss}
        >
          <h4>{header}</h4>
          <p>{text}</p>
        </Alert>
      </CSSTransition>
    );
  }
}

export default Notification;



// WEBPACK FOOTER //
// ./src/containers/Notification.js